/** @file axesLocal: a unit-frame point in the Babylon local coordinates of an axes-frame gizmo node. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** `(x, y, z) -> (x, z, y)`: the gizmo's Z (up) is Babylon's y, as `toBabylonVec3` maps world points. */
export function axesLocal(p: Vec3): Vec3 {
  return [p[0], p[2], p[1]];
}
